/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ProgressBarSquareModel} from './models/progress-bar-square.model';

@Component({
    selector: 'app-progress-bar-square',
    templateUrl: './progress-bar-square.component.html',
    styleUrls: ['./progress-bar-square.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressBarSquareComponent implements OnInit {
    @Input() squares: ProgressBarSquareModel;
    readonly DEFAULT_SQUARE_COLOR = '#efefef';
    activeElements: boolean[][];

    ngOnInit(): void {
        this.activeElements = this.retrieveSquareElements();
    }

    retrieveSquareBackground(line: boolean): string {
        return line ? this.squares.squaresBackgroundActive : this.DEFAULT_SQUARE_COLOR;
    }

    private retrieveSquareElements(): boolean[][] {
        const result: boolean[][] = [];
        let squaresActive = this.squares.squaresActive;
        const maxSquares = this.squares?.maxLineSquares ?? 1;

        if (this.squares.maxLineSquares !== this.squares.totalSquares) {
            const squareCount = Math.ceil(this.squares?.squaresActive / maxSquares);
            for (let rowIndex = 0; rowIndex < squareCount; rowIndex++) {
                const rowValues: boolean[] = [];
                for (let lineIndex = 0; lineIndex < this.squares?.maxLineSquares; lineIndex++) {
                    rowValues.push(squaresActive > 0);
                    squaresActive--;
                }
                result.push(rowValues);
            }
        } else {
            result.push(this.retrieveActiveSquares());
        }
        return result;
    }

    private retrieveActiveSquares(): boolean[] {
        const rowValues: boolean[] = [];
        let squaresActive = this.squares.squaresActive;

        for (let rowIndex = 0; rowIndex < this.squares?.maxLineSquares; rowIndex++) {
            rowValues.push(squaresActive > 0);
            squaresActive--;
        }
        return rowValues;
    }
}
